// Regular expression that determines if the input is a float
export const floatValidationRegex = /^[0-9]+(\.[0-9]+)?$/u;

export const floatValidationPattern = floatValidationRegex.source;
